// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tag":"Tag_pintxo-tag__i8Vcm"};